import { Quote } from "lucide-react";
import { FadeUp } from "./Reveal";

/**
 * PinnedThankYou — the student's newest grant thank-you, shown at the very
 * top of their campaign page so the people who gave see it first.
 */
export const PinnedThankYou = ({ thankYou, studentName }) => {
  if (!thankYou?.message) return null;
  const when = thankYou.posted_at
    ? new Date(thankYou.posted_at).toLocaleDateString("en-US", { month: "long", day: "numeric" })
    : null;
  const amount = thankYou.amount_cents ? `$${Math.round(thankYou.amount_cents / 100).toLocaleString()}` : null;
  return (
    <FadeUp>
      <figure
        data-testid="pinned-thank-you"
        className="relative mt-6 overflow-hidden rounded-lg border-2 border-grass bg-grass/[0.06] px-6 py-6 lg:px-8"
      >
        <span className="absolute -right-3 -top-3 text-grass/15"><Quote className="h-24 w-24" strokeWidth={1.5} /></span>
        <figcaption className="text-[13px] font-semibold uppercase tracking-[0.22em] text-grass">
          A thank-you from {studentName}{amount ? ` · after a ${amount} grant` : ""}
        </figcaption>
        <blockquote className="relative mt-3 max-w-3xl font-serif text-3xl leading-snug text-ink" data-testid="pinned-thank-you-text">
          “{thankYou.message}”
        </blockquote>
        <p className="mt-3 text-[13px] text-olive">
          {studentName}{when ? ` · ${when}` : ""}. Grants are awarded by My Rich Aunt from the gifts of everyone who gave with {studentName} in mind.
        </p>
      </figure>
    </FadeUp>
  );
};
